export const environment = {
    production: false,
    assetUrl: 'EBUERO_STATIC_PATH_PLACEHOLDER/web-components'
};

// EBUERO_SERVER_PATH_PLACEHOLDER
